import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

const MobileFixedButtons = lazy(() => import(/* webpackChunkName: "responsiveFrontendMobileFixedButtonsWhereItsOnlySearch" */ '@PROJECT_ROOT/assets/responsive-frontend/js/search/searchDock'));

export default function initMobileFixedButtonsWhereItsOnlySearch() {
    let isInitialized = false;
    let isScheduled = false;

    function loadSearchDock() {
        if (isInitialized || window.innerWidth >= 991) return;
        const mobileFixedButtons = document.getElementById('mobileFixedButtonsReact');
        if (!mobileFixedButtons) return;
        isInitialized = true;
        const root = createRoot(mobileFixedButtons);
        root.render(
            <Suspense fallback="">
                <MobileFixedButtons />
            </Suspense>,
        );
    }

    function scheduleSearchDock() {
        if (isInitialized || isScheduled || window.innerWidth >= 991) return;
        isScheduled = true;
        const load = () => {
            isScheduled = false;
            if (window.innerWidth < 991) {
                loadSearchDock();
            }
        };

        if ('requestIdleCallback' in window) {
            // TODO: Povecao bih do 1.5 - provjerit sa Tihanom.
            window.requestIdleCallback(load, { timeout: 500 });
        } else {
            setTimeout(load, 800);
        }
    }

    scheduleSearchDock();

    window.addEventListener('resize', () => {
        if (window.innerWidth < 991 && !isInitialized) {
            scheduleSearchDock();
        }
    });
}
